import React from 'react';
import { Content } from '../../../infrastructure/content';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';

const SwitchDateTermsLink = ({ isCurrentAccountSwitch, switchDateTermsLinkHref }) => (
  <Content>
    {({ switchDateTermsLinkText = '', switchDateTermsCurrentAccLinkText }) => (
      <WebsiteLink
        linkText={
          isCurrentAccountSwitch ? switchDateTermsCurrentAccLinkText : switchDateTermsLinkText
        }
        willOpenNewWindow
        url={switchDateTermsLinkHref}
      />
    )}
  </Content>
);

export default SwitchDateTermsLink;
